import axios from 'axios';

const getApiBaseUrl = () => (import.meta as any).env.VITE_API_BASE_URL || window.location.origin;

const getApiKey = () => {
  // First try to get from environment variable
  const envKey = (import.meta as any).env.VITE_API_KEY;
  if (envKey) {
    console.log('Using API key from environment:', envKey.substring(0, 10) + '...');
    return envKey;
  }

  // Fallback to localStorage
  const storedKey = localStorage.getItem('api_key');
  if (storedKey) {
    console.log('Using API key from localStorage:', storedKey.substring(0, 10) + '...');
    return storedKey;
  }

  // No API key found - that's okay for public endpoints
  console.log('No API key found - using public access');
  return null;
};

// Create axios instance with default config
const api = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  timeout: 30000 // 30 second timeout
});

// Add request interceptor to handle token and log headers
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Add API key if available
  const apiKey = getApiKey();
  if (apiKey) {
    config.headers['X-API-Key'] = apiKey;
  }
  
  // Log request details for debugging
  console.log('API Request:', {
    method: config.method?.toUpperCase(),
    url: config.url,
    headers: {
      'X-API-Key': config.headers['X-API-Key'] ? '***' + config.headers['X-API-Key'].slice(-4) : 'Not set',
      'Authorization': config.headers.Authorization ? 'Bearer ***' : 'Not set'
    }
  });
  
  return config;
}, (error) => {
  console.error('Request interceptor error:', error);
  return Promise.reject(error);
});

// Add response interceptor for debugging and error handling
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', {
      status: response.status,
      url: response.config.url,
      data: response.data
    });
    return response;
  },
  (error) => {
    console.error('API Error:', {
      status: error.response?.status,
      url: error.config?.url,
      message: error.response?.data?.message || error.message,
      error: error.response?.data
    });
    
    // Handle specific error cases
    if (error.response?.status === 401) {
      console.error('Authentication failed. Please check your API key.');
    } else if (error.response?.status === 500) {
      console.error('Server error. Please try again later.');
    }
    
    return Promise.reject(error);
  }
);

export default api; 

